import { render } from "./OOCAnalysisPage.vue?vue&type=template&id=45cbc7e8&scoped=true&ts=true"
import script from "./OOCAnalysisPage.vue?vue&type=script&lang=ts"
export * from "./OOCAnalysisPage.vue?vue&type=script&lang=ts"

import "./OOCAnalysisPage.vue?vue&type=style&index=0&id=45cbc7e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45cbc7e8"]])

export default __exports__